<template>
  <element>
    <AppBar :title="task ? task.taskName : ''" />
    <v-container class="m-0 py-0">
      <v-icon class="icon" size=60 color="#2E384D">mdi-hammer-screwdriver </v-icon>
      <h5 class="subtitle w-100 text-center">{{ $t('manualTask.subtitle') }} {{ task ? task.name : '' }}</h5>
      <p class="description text-center px-3">{{ $t('manualTask.description') }}</p>
      <v-row class="px-3" no-gutters>
        <v-btn color="#033E8C" height=40 :dark="!disabled" block :disabled="disabled" @click="completeTask">{{ $t('manualTask.button-1') }}</v-btn>
      </v-row>
      <v-row class="px-3 mt-5" no-gutters>
        <v-btn color="#FF0000" height=40 :dark="!disabled" block :disabled="disabled" @click="makeFeedback">{{ $t('manualTask.button-2') }}</v-btn>
      </v-row>
    </v-container>
  </element>
</template>

<script>
import AppBar from "@/components/common/AppBar.vue"

export default {
  name: "ManualTaskPage",
  props: {
  },
  components: {
    AppBar
  },
  data() {
    return {
      task: null,
      disabled: false,
    }
  },
  methods: {
    completeTask() {
      this.disabled = true
      this.$store.dispatch('showNotification', { 
        text: 'taskCompleted', 
        interval: 4000})
      this.$store.dispatch('completeTask', this.task.id)
      .then(response => {
        console.log(response)
      })
      .catch(error => {
        console.log(error)
      })
    },
    makeFeedback() {
      this.$store.dispatch('showFeedbackDialog')
    }
  },
  created() {
    this.task = this.$store.getters.getCurrentTask
  }
}
</script>

<style scoped>
.icon {
  margin-top: 2.5rem;
  margin-bottom: 2.75rem;
}

.subtitle {
  color: #2E384D;
  font-size: 1.25rem;
  font-weight: bold;
}

.description {
  font-size: 0.875rem;
  font-weight: lighter;
  color: #2E384D;
  margin-top: 2.5rem;
  margin-bottom: 8rem;
}
</style>